const destabsespd = document.querySelectorAll('.destabs__btnpd');
const tabsContent = document.querySelectorAll('.destabs__bodypd');

if (tabsContent.length > 0 || tabs.length > 0) {
    function hideAllTabContent() {
        tabsContent.forEach(item => {
            item.style.opacity = '0'; // Set opacity to 0 to hide tab content
            item.classList.remove('active');
            item.style.display = 'none';
        });

        destabsespd.forEach(item => {
            item.classList.remove('active');
        });
    }

    function toggleTabContent(index) {
        if (tabsContent[index].classList.contains('active')) {
            hideAllTabContent();
        } else {
            hideAllTabContent();
            tabsContent[index].style.display = 'block'; // Display the tab content

            setTimeout(() => {
                tabsContent[index].style.opacity = '1'; // Set opacity to reveal content
                tabsContent[index].classList.add('active');
                destabsespd[index].classList.add('active');
            }); // Adding a slight delay before showing the tab content
        }
    }

    hideAllTabContent(); // Hide all tabs initially

    destabsespd.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            toggleTabContent(index);
        });
    });
}
